{
  "name": "webapp",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --configuration development",
    "build:staging": "ng build --configuration staging",
    "build:production": "ng build --configuration production",
    "commit": "cz",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "npm run lint:app && npm run lint:scss",
    "lint:app": "ng lint",
    "lint:scss": "stylelint \"src/**/*.scss\"",
    "lint:app:fix": "ng lint --fix",
    "lint:scss:fix": "stylelint \"src/**/*.scss\" --fix"
  },
  "private": true,
  "dependencies": {
    "@angular-architects/ngrx-toolkit": "^19.0.2",
    "@angular/animations": "^19.0.0",
    "@angular/common": "^19.0.0",
    "@angular/compiler": "^19.0.0",
    "@angular/core": "^19.0.0",
    "@angular/forms": "^19.0.0",
    "@angular/material": "^19.1.4",
    "@angular/platform-browser": "^19.0.0",
    "@angular/platform-browser-dynamic": "^19.0.0",
    "@angular/router": "^19.0.0",
    "@jsverse/transloco": "^7.5.1",
    "@ng-select/ng-select": "^14.2.4",
    "@ngneat/dialog": "^5.1.2",
    "@ngneat/helipopper": "^10.2.0-alpha.2",
    "@ngrx/operators": "^19.0.1",
    "@ngrx/signals": "^19.0.1",
    "apexcharts": "^4.5.0",
    "google-libphonenumber": "^3.2.40",
    "jsvat": "^2.5.4",
    "lottie-web": "^5.12.2",
    "luxon": "^3.7.2",
    "marked": "^15.0.7",
    "ng-apexcharts": "^1.15.0",
    "ngx-intl-tel-input-gg": "^1.0.12",
    "ngx-lottie": "^13.0.1",
    "ngx-mask": "^19.0.6",
    "ngx-skeleton-loader": "^10.0.0",
    "ngx-toastr": "^19.0.0",
    "ngxsmk-datepicker": "^2.2.11",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.0.5",
    "validator": "^13.15.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.6",
    "@angular/cli": "^19.0.6",
    "@angular/compiler-cli": "^19.0.0",
    "@commitlint/cli": "^19.6.1",
    "@commitlint/config-conventional": "^19.6.0",
    "@types/jasmine": "~5.1.0",
    "@types/validator": "^13.15.0",
    "angular-eslint": "19.0.2",
    "autoprefixer": "^10.4.20",
    "commitizen": "^4.3.1",
    "eslint": "^9.16.0",
    "eslint-plugin-simple-import-sort": "^12.1.1",
    "eslint-plugin-unused-imports": "^4.1.4",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.1",
    "prettier": "^3.4.2",
    "stylelint": "^16.13.2",
    "stylelint-config-idiomatic-order": "^10.0.0",
    "stylelint-config-standard-scss": "^14.0.0",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.6.2",
    "typescript-eslint": "8.18.0"
  },
  "config": {
    "commitizen": {
      "path": "./commitizen.config.js"
    }
  },
  "packageManager": "npm@11.16.0+sha512.03be172fc3b199c7a06433163e459be5b110a6983c1dd6305b7ac10f6b0fa12e1440755a8df6b1064ab2ccb789df0474919fb9c684e322dc57685ede21752ccb"
}
